import { IOrderNoProductAction } from '@lentau/order/no-product-action/shared/models/interfaces';
import { EventProperties } from '@lentau/analytics/health-metrics/shared';
import { CartDataProps, CartPromocode } from '@lentau/cart/shared/interfaces';
import { OrderPaymentTypeChangeResult } from '@lentau/payment/type/shared/types';
import { ResponseCommonProps } from '@lentau/api/shared/monolith/types';
import { OrderModifyRequest } from '@lentau/order/ordering/store/shared/interfaces';
import { PaymentTypeInfo } from '@lentau/payment/shared';
import { AddOrderFinalResponse } from '@lentau/order/checkout/shared/interfaces';
import { checkEmptyFields } from '../utils';
import { Bonuses } from '@lentau/loyalty/order/store/interfaces';

export function loyaltyApplyPointsToOrderHandler(data: Bonuses): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.deltaMinimalCost,
        errorName: 'deltaMinimalCostIsEmpty',
      },
      {
        fieldToCheck: data?.appliablePercent,
        errorName: 'appliablePercentIsEmpty',
      },
      {
        fieldToCheck: data?.appliablePoints,
        errorName: 'appliablePointsIsEmpty',
      },
      {
        fieldToCheck: data?.isUsePointAccess,
        errorName: 'isUsePointAccessIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function orderPaymentTypeChangeHandler(data: OrderPaymentTypeChangeResult): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.OrderId,
        errorName: 'OrderIdIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function orderModifyHandler(data: OrderModifyRequest): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.Id,
        errorName: 'IdIsEmpty',
      },
      {
        fieldToCheck: data?.PaymentTypeId,
        errorName: 'PaymentTypeIdIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function userModifyHandler({ Body }: ResponseCommonProps): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: Body?.result,
        errorName: 'resultIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function orderBuyerNoteSaveCartHandler(comment: string): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: comment,
        errorName: 'commentEmptyIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function cartModifyHandler(data: CartDataProps): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.CartList[0]?.DeliveryIntervalId,
        errorName: 'DeliveryIntervalIdIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function cartPromocodeAddHandler(data: CartPromocode): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.Code,
        errorName: 'CodeIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function cartFromOrderAddHandler(data: AddOrderFinalResponse): EventProperties {
  {
    const result = data?.Response?.Body?.OrderList[0];
    const fields = [
      {
        fieldToCheck: result?.Id,
        errorName: 'IdIsEmpty',
      },
      {
        fieldToCheck: result?.TotalCost,
        errorName: 'TotalCostIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function responseLookupHandler(data: AddOrderFinalResponse): EventProperties {
  {
    const result = data?.Response?.Body?.OrderList[0];
    const fields = [
      {
        fieldToCheck: result?.Id,
        errorName: 'IdIsEmpty',
      },
      {
        fieldToCheck: result?.TotalCost,
        errorName: 'TotalCostIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function cartPromocodeDeleteHandler(data: CartPromocode): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.Code,
        errorName: 'CodeIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function paymentTypeSearchHandler(data: PaymentTypeInfo): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.DefaultPaymentType,
        errorName: 'DefaultPaymentTypeIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function noproductactionsHandler(data: { actions: IOrderNoProductAction[] }): EventProperties {
  {
    const result = data.actions[0];

    const fieldsToCheck = [
      {
        fieldToCheck: result?.id,
        errorName: 'idIsEmpty',
      },
      {
        fieldToCheck: result?.text,
        errorName: 'textIsEmpty',
      },
      {
        fieldToCheck: result?.description,
        errorName: 'descriptionIsEmpty',
      },
    ];

    return checkEmptyFields(fieldsToCheck);
  }
}

export function loyaltyGetAppliablePointsHandler(data: Bonuses): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data.deltaMinimalCost,
        errorName: 'deltaMinimalCostIsEmpty',
      },
      {
        fieldToCheck: data.appliablePercent,
        errorName: 'appliablePercentIsEmpty',
      },
      {
        fieldToCheck: data.appliablePoints,
        errorName: 'appliablePointsIsEmpty',
      },
      {
        fieldToCheck: data.isUsePointAccess,
        errorName: 'isUsePointAccessIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}
